import seo from '@/data/seo.json';

function setMeta(attribute, name, content) {
    let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

export function updateSeo(route) {
    // Query strings and section anchors do not create separate search pages.
    const path = route.path.replace(/\/+$/, '') || '/';
    const page = Object.prototype.hasOwnProperty.call(seo.pages, path) ? seo.pages[path] : null;
    const title = page?.title || seo.siteName;
    const description = page?.description || '';
    const isPublic = page && page.index !== false && !route.meta?.requiresAuth;

    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', isPublic ? 'index, follow' : 'noindex, follow');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', seo.siteName);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (page) {
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.rel = 'canonical';
            document.head.appendChild(canonical);
        }
        canonical.href = seo.origin + path;
        setMeta('property', 'og:url', seo.origin + path);
    } else {
        canonical?.remove();
        document.head.querySelector('meta[property="og:url"]')?.remove();
    }
}
